module.exports = {
  "country": "AM",
  "artist": "Sirusho",
  "song": "Qele, Qele",
  "year": "2008",
  "place": "4",
  "spotify": "3f89Rw7YxjXf9pdCXZCCk1"
};